import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../widgets/TextInput";
import FixButton from "../widgets/Button";
import getAgente from "../services/getAgente";
import editAgente from "../services/editAgente";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

export default class EditAgente extends React.Component {
    constructor(props){
        super (props)

        this.state = {
            clientePrivato: false,
            ragioneSociale: '',
            partitaIva: ''
        };

    }

    async componentDidMount() {

        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });    

        let current = cookies.get('agente', { path: '/' });
        let agente = await getAgente(username, token, current);

        this.setState({ clientePrivato: agente.is_privato === '1', ragioneSociale: agente.ragione_sociale, partitaIva: agente.p_iva });
    }

    render () {

        return (
        <>
            <PageTitle title={'Modifica agente'} />  

            <div style={{ display: 'flex', width: 300, alignItems: 'center', justifyContent: 'center' }}>
                <p style={{ ...selectionButton, backgroundColor: this.state.clientePrivato ? 'darkgrey' : 'white', color: this.state.clientePrivato ? 'black' : 'darkgrey'  }} onClick={() => this.setState({clientePrivato: true})}>Privato</p>
                <p style={{ ...rightSelectionButton, backgroundColor: !this.state.clientePrivato ? 'darkgrey' : 'white', color: !this.state.clientePrivato ? 'black' : 'darkgrey'  }} onClick={() => this.setState({clientePrivato: false})}>Azienda</p>
            </div>  
            <TextInput name={this.state.clientePrivato ? 'Nome e cognome' : 'Ragione Sociale'} value={this.state.ragioneSociale} 
                onChange={(text) => { this.setState({ragioneSociale: text})}
            } />

            <TextInput name={this.state.clientePrivato ? 'Codice fiscale' : 'Partita IVA'} value={this.state.partitaIva} 
                onChange={(text) => { this.setState({partitaIva: text})}
            } />

            <div style={{ height: 30 }}></div>
            <FixButton title={'Salva'} callback={() => this.save()} />
        </>
        );
    }

    async save() {

        this.setState({ isLoading: true });
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        if (!this.state.ragioneSociale) {
            alert('Inserire ' + (this.state.clientePrivato ? 'un nome valido' : 'una ragione sociale valida'));
            return;
        }

        if (!this.state.partitaIva || (this.state.clientePrivato && this.state.partitaIva.length !== 16) || (!this.state.clientePrivato && (this.state.partitaIva.length !== 11 && this.state.partitaIva.length !== 13))) {
            alert('Inserire ' + (this.state.clientePrivato ? 'un codice fiscale valido' : 'una partita iva valida'));
            return;
        }

        let agente = {
            id: cookies.get('agente', { path: '/' }), 
            ragione_sociale: this.state.ragioneSociale, 
            p_iva: this.state.partitaIva, 
            is_privato: this.state.clientePrivato, 
        };

        let res = await editAgente(username, token, agente);
        if (res.result === 'ok') {
            window.location.href = '/#/app/agenti';
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la modifica dell\'agente. Per favore, riprova.');
    }

}

const selectionButton = {
    height: 30,
    width: 140,
    marginLeft: 5,
    borderTopLeftRadius: 15,
    borderBottomLeftRadius: 15,
    textAlign: 'center',
    paddingTop: 4,
    cursor: 'pointer'
}

const rightSelectionButton = {
    height: 30,
    width: 140,
    marginLeft: 5,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    textAlign: 'center',
    paddingTop: 4,
    cursor: 'pointer'
}

